import { ComponentContainer } from '@styles/layout';
import { DescriptionComponent } from '@model/content';
import { TextDescriptionFade } from '@components/common/description/TextDescriptionFade';

export const IntroContainer = ({ value, showReadMore }: DescriptionComponent) => {
  return (
    <ComponentContainer>
      <TextDescriptionFade description={value} isExpanded={showReadMore === false} />
    </ComponentContainer>
  );
};
